import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import SERVICEAPI from "../../Api/serviceapi"
import { setMessage } from "./message"
import EventBus from "../../utils/EventBus"

export const fetchService = createAsyncThunk("service/fetchService", async (params, thunkAPI) => {
  try {
    const response = await SERVICEAPI.getService(params)
    
    // console.log("res",response)
    return response.data   
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message)
  }
})

export const getServiceById = createAsyncThunk("service/getServiceById", async (id, thunkAPI) => {
  try {
    const response = await SERVICEAPI.getServiceById(id)
    
    // console.log("res",response.data.message)
    return response.data   
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message)
  }
})

export const createService = createAsyncThunk("service/createService", async (formData, thunkAPI) => {
  try {
    const response = await SERVICEAPI.addService(formData)
    const message=(response.message)

    thunkAPI.dispatch(setMessage(message))

    return response
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})

export const deleteService = createAsyncThunk("service/deleteService", async (id, thunkAPI) => {
  try {
    const response = await SERVICEAPI.deleteService(id)
    const message=(response.data.message)
    

    thunkAPI.dispatch(setMessage(message))

    return id
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  } 
})

export const updateService = createAsyncThunk("service/updateService", async ({id,formData}, thunkAPI) => {
  try {
    const response = await SERVICEAPI.updateService(id,formData)
    const message=(response.message)
    
    thunkAPI.dispatch(setMessage(message))

    return response
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message))
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})

const ServiceSlice = createSlice({
  name: "service",
  initialState: {
    services: [],
    serviceDetails:"",
    totalPages: "",
    totalCount: 0,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      .addCase(getServiceById.fulfilled, (state, action) => {
        state.serviceDetails = action.payload.data
        state.loading = false
      })
      .addCase(getServiceById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(fetchService.fulfilled, (state, action) => {
        state.services = action.payload.data
        state.totalPages = action.payload.totalPages
        state.totalCount = action.payload.totalCount
        state.loading = false
      })
      .addCase(fetchService.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      .addCase(createService.fulfilled, (state, action) => {
        state.services.push(action.payload.data)
        state.loading = false
      })
      .addCase(createService.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      .addCase(deleteService.fulfilled, (state, action) => {
        console.log("act:",action.payload);
        state.services = state.services.filter((service) => service._id !== action.payload.data)
        state.loading = false
      })
      .addCase(deleteService.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      }) 

      .addCase(updateService.fulfilled, (state, action) => {
        
        const updatedService = action.payload.data
        console.log("update:",updatedService);
        
        state.services = state.services.map((service) => (service._id === updatedService._id ? updatedService : service))
        state.loading = false
      })
      .addCase(updateService.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },  
})

const { reducer } = ServiceSlice
export default reducer
